export const PROJECTS__SET_PROJECT_SUBSCRIPTION = projectSubscription => {
    return {
        type: 'PROJECTS__SET_PROJECT_SUBSCRIPTION',
        payload: projectSubscription,
    }
}
